const VIEWPORT_PAD = 8;

export function computeToolbarFilterPopoverLayout(anchorRect, width = 400, maxHeightCap = 460) {
  let left = anchorRect.left;
  let top = anchorRect.bottom + 4;

  if (left + width > window.innerWidth - VIEWPORT_PAD) {
    left = window.innerWidth - width - VIEWPORT_PAD;
  }
  if (left < VIEWPORT_PAD) left = VIEWPORT_PAD;

  const spaceBelow = window.innerHeight - anchorRect.bottom - VIEWPORT_PAD;
  let flipped = false;
  if (spaceBelow < 220 && anchorRect.top > 220) {
    top = anchorRect.top - 4;
    flipped = true;
  }

  const available = flipped
    ? anchorRect.top - VIEWPORT_PAD - 4
    : window.innerHeight - anchorRect.bottom - VIEWPORT_PAD - 4;
  const cap = Math.min(maxHeightCap, window.innerHeight - VIEWPORT_PAD * 2);
  const maxHeight = Math.max(200, Math.min(cap, available));

  return {
    position: 'fixed',
    top,
    left,
    width,
    boxSizing: 'border-box',
    zIndex: 1110,
    maxHeight,
    '--bsf-cidade-popover-max-h': `${maxHeight}px`,
    flipped,
  };
}
